import { Component, Input, OnInit } from '@angular/core';
import { FreudDialogService } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';
import * as IAction from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';

@Component({
	selector: 'promptuary-compliance-modal',
	templateUrl: './promptuary-compliance-modal.html',
	styleUrls: ['./promptuary-compliance-modal.scss'],
})
export class PromptuaryComplianceModal implements OnInit {
	isPsychologist: boolean;

	@Input() type: 'default' | 'crm';
	@Input() from;
	@Input() mainType;
	constructor(
		public translateService: TranslateService,
		public dialogService: FreudDialogService,
		public actionTrackerService: ActionTrackerService
	) {}

	ngOnInit(): void {
		this.setAttributesFromDialogService();
		this.isPsychologist = this.mainType === 'psychologist';

		this.actionTrackerService.eventTracker(
			IAction.SCOPE_TYPE.Promptuary,
			IAction.SUBSCOPE_TYPE.Details,
			IAction.ITEM_TYPE.PromptuaryComplianceModal,
			IAction.INTERACTION_TYPE.View,
			{
				specialist_type: this.mainType,
				from: this.from,
			}
		);
	}

	private setAttributesFromDialogService() {
		const dialogContextData = this.dialogService?.dialogComponentRefMap
			?.entries()
			?.next()?.value[1]?.instance?.config?.data;

		if (dialogContextData) {
			this.type = dialogContextData.type;
			this.from = dialogContextData.from;
			this.mainType = dialogContextData.mainType;
		}
	}
}
